import { useEffect, useRef } from 'react';
import { setWallet as setSVMWallet, isSvmProgramInitialized } from '../../chains/svm/api';
export function useSvmEffects({ initStatus, svmWallet, walletAddresses, setWalletAddresses, updateAllSVMChains, isWalletAuthenticated, }) {
    const wasAuthenticatedRef = useRef(false);
    useEffect(() => {
        const newSVMAddress = svmWallet.publicKey?.toString();
        if (initStatus.svm && isSvmProgramInitialized() && walletAddresses.svm != newSVMAddress) {
            setWalletAddresses((prev) => ({
                ...prev,
                svm: newSVMAddress,
            }));
            setSVMWallet(svmWallet);
            // Global/public until wallet sign-in; personal gated in updateChainState.
            updateAllSVMChains(Boolean(svmWallet.publicKey));
        }
    }, [svmWallet, walletAddresses.svm, initStatus.svm]);
    useEffect(() => {
        if (!initStatus.svm)
            return;
        const justAuthenticated = isWalletAuthenticated && !wasAuthenticatedRef.current;
        wasAuthenticatedRef.current = isWalletAuthenticated;
        if (!justAuthenticated || !svmWallet.publicKey)
            return;
        updateAllSVMChains(true);
    }, [initStatus.svm, isWalletAuthenticated, svmWallet.publicKey, updateAllSVMChains]);
}
